import React from 'react';

function LargeCheckmarkIcon() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 40" enableBackground="new 0 0 50 40">
      <polygon  fill="#9D9D9C" points="48,6 17.2,38 2,22 6,18 17.2,30 44,2 "/>
    </svg>
  );
}

export default LargeCheckmarkIcon;



// WEBPACK FOOTER //
// ./src/components/icons/LargeCheckmarkIcon.js